//Styles
import Styles from "./BaseNativeAppContainer.module.scss";
import classnames from "classnames";

//module
import Draggable from 'react-draggable'

//Components

//Icon
import { ReactComponent as GalleryIcon } from "../../icons/app/layer.svg"
import { ReactNode } from "react";
import SearchBox from "../search_box/SearchBox";
import BaseNativeAppBar from "../base-native-app-bar/BaseNativeAppBar";


//Redux
import { closeWindow } from "../../actions";
import { useDispatch } from "react-redux";

import { useTransition, animated } from "react-spring";
import { useState } from "react";
import { getSizeInRem } from "../../global/functions/functrions";


interface BaseAppContainerProps {
    appId: string;
    loadFromX:number;
    loadFromY?:number;
    width?: number;
    height?: number;
    title: string;
    MainScreen: ReactNode;
    showHeader?: boolean;
    lighTheme?: boolean;
    onClickPreviousIcon?:()=>void;
    onClickNextIcon?:()=>void;
    onClosedSuccessfully?:()=>void;
    
}


const BaseNativeAppContainer = ({ appId,loadFromX, loadFromY, width = 1000, height = 700, title, MainScreen, showHeader = false, lighTheme = false,onClickPreviousIcon
    ,onClickNextIcon,onClosedSuccessfully }: BaseAppContainerProps) => {
    const [isVisible, setIsVisible] = useState(true)
    const dispatch = useDispatch()

    const onClickCLoseWindow = () => {
        setIsVisible(false)
        setTimeout(() => {
            dispatch(closeWindow(appId))
            onClosedSuccessfully?.()
        }, 100)
    }


    const transition = useTransition(isVisible, {
        from: {
            x: loadFromX, y: loadFromY, opacity: 0, scale: 0
        },
        enter: {
            x: 0, y: 0, opacity: 1, scale: 1
        },
        leave: {
            x: loadFromX, y: loadFromY, opacity: 0, scale: 0
        }
    })

    return (
        <>

            {transition((style) =>
                <animated.div style={style}>

                    <Draggable >
                        <div className={classnames(Styles.container,"glassBackground",lighTheme && Styles.glass_bg)} style={{ width: getSizeInRem(width), height: getSizeInRem(height), backgroundColor:`${!lighTheme?"var(--mainbk)":"" }` }} >
                            <BaseNativeAppBar title={title} onClickCLoseWindow={onClickCLoseWindow} />
                            <div className={Styles.content}>
                                {MainScreen}
                            </div>
                        </div>
                    </Draggable>
                </animated.div>
            )}

        </>
    )
}

export default BaseNativeAppContainer
